// Central brand identity — primary/secondary/tertiary colors, key gradients, and
// key shadows used across the app. No ThemeProvider: this app has no existing
// theme wiring, so these are plain constants imported directly by components
// (`import { theme } from '.../styles/theme'`, then `${theme.colors.primary}`
// inside styled-components template literals).
//
// Values were extracted from what's already hardcoded throughout the app —
// changing a value here changes it everywhere it's referenced, but do not
// change these values casually: many components still hardcode the same hex
// directly and won't pick up the change until they're migrated too.
export const theme = {
  colors: {
    primary: '#4F3FE0', // brand violet — flagship accent (navbar, sidebar, edges)
    primaryHover: '#8172FF',
    primaryDark: '#2A2070',
    secondary: '#7c3aed', // violet — admin/agent flavor
    secondaryLight: '#8b5cf6',
    tertiary: '#2563eb', // blue — chat/user flavor
    tertiaryLight: '#0ea5e9',
    background: '#EDEBFA',
    backgroundAlt: '#F1EFFA',
    cardBackground: '#FBFAFE',
    border: '#E6E2F6',
    text: '#171226',
    textSecondary: '#6B6584',
    textTertiary: '#9C97B3',
    coral: '#D9573F',
    amber: '#E8963C',
    green: '#3FCB8C',
    cyan: '#54E0D0',
  },
  gradients: {
    primary: 'linear-gradient(150deg, #8172FF, #4F3FE0 75%)',
    secondary: 'linear-gradient(135deg, #7c3aed, #6d28d9)',
    tertiary: 'linear-gradient(135deg, #2563eb, #0ea5e9)',
  },
  shadows: {
    card: '0 2px 4px rgba(29, 20, 70, 0.04), 0 16px 32px -12px rgba(29, 20, 70, 0.10), 0 40px 80px -26px rgba(29, 20, 70, 0.20)',
    subtle: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    medium: '0 8px 24px -12px rgba(42, 32, 112, 0.18)',
    // Shared float chrome (top toolbar / zoom stacks / status chips)
    float: '0 1px 2px rgba(29, 20, 70, 0.05), 0 8px 16px -8px rgba(29, 20, 70, 0.14), 0 20px 40px -18px rgba(29, 20, 70, 0.18)',
  },
  // Neutral surface tokens for floating canvas chrome — shared by toolbar,
  // canvas-controls, and status chips so they read as one system.
  surface: {
    groupBg: '#FBFAFE',
    groupBorder: '#E6E2F6',
    hoverFill: '#F1EFFA',
    mutedText: '#9C97B3',
  },
};
